// One fixed, page-spanning background that every section scrolls over — this is what
// makes the page feel connected instead of a stack of boxed-off panels. Layers:
//   1. layered-dark base + soft "aurora" glows (warm + cool) for depth,
//   2. a continuous, very faint "spacetime" grid (the gravity motif, echoing the hero),
//   3. fine film grain to add richness and kill gradient banding.
// Purely decorative and non-interactive.
const GRAIN =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E\")";

export default function PageBackground() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10">
      {/* base + aurora glows */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(55% 42% at 50% 12%, rgba(233,210,23,0.05), transparent 62%),' +
            'radial-gradient(50% 50% at 86% 82%, rgba(90,110,150,0.045), transparent 60%),' +
            'radial-gradient(45% 45% at 10% 58%, rgba(233,210,23,0.035), transparent 60%),' +
            '#000',
        }}
      />
      {/* continuous spacetime grid, faded toward the edges */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, rgba(255,255,255,0.045) 0 1px, transparent 1px 56px),' +
            'repeating-linear-gradient(90deg, rgba(255,255,255,0.045) 0 1px, transparent 1px 56px)',
          WebkitMaskImage: 'radial-gradient(120% 80% at 50% 32%, #000 30%, transparent 90%)',
          maskImage: 'radial-gradient(120% 80% at 50% 32%, #000 30%, transparent 90%)',
        }}
      />
      {/* film grain */}
      <div className="absolute inset-0 opacity-50 mix-blend-overlay" style={{ backgroundImage: GRAIN }} />
    </div>
  );
}
